import { Button, Form, message, Modal, notification } from "antd";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { closeModal } from "store/slices/modalsSlice";
import CategorieForm from "./Supplement-Form";
import useSubscriptionCategories from "hooks/useSubscriptionCategories";

const EditCategorieModal = () => {
    const { t } = useTranslation();
    const [form] = Form.useForm();
    const dispatch = useDispatch();
    const { isModalOpen, modalType, modalProps } = useSelector(
        (state) => state.modals
    );
    const { getCategorieById, updateCategorie, Categorie, setCategorie, isLoading, error, setError } = useSubscriptionCategories();
    const [isSendForUpdate, setIsSendForUpdate] = useState(false);
    // useEffect(() => {
    //   if (Categorie && !isLoading) {
    //     console.log("🟣 Données de la catégorie chargées :", Categorie); 
    //     form.setFieldsValue({
    //       name: Categorie.name,
    //       price: parseFloat(Categorie.price),
    //       description: Categorie.description,
    //       // Correction clé : Utiliser la valeur numérique et s'assurer du type
    //       // ageSectionId: Number(Categorie.ageSection?.id) || null 
    //       // ageSectionId: Number(Categorie.ageSectionId) || null
    //       ageSectionId: Categorie.ageSectionId ? Number(Categorie.ageSectionId) : null
    //     });
    //   }
    // }, [Categorie, isLoading, form]);
    useEffect(() => {
      if (Categorie && !isLoading) {
        form.setFieldsValue({
          name: Categorie.name,
          price: parseFloat(Categorie.price),
          description: Categorie.description,
          // Correction clé : Accès à l'ID via l'objet ageSection
          ageSectionId: Number(Categorie.ageSection?.id) || null 
        });
      
      }
    }, [Categorie, isLoading, form]);

    useEffect(() => {
        if (modalProps?.categorieId) {
          setCategorie(null);
            const getCategorie = async () => {
                try {
                    await getCategorieById(modalProps.categorieId);
                } catch (error) {
                    console.log("Erreur lors de la récupération de l'employee", error);
                }
            };
            getCategorie();
        }
    }, [modalProps?.categorieId]);


    useEffect(() => {
        if (isSendForUpdate) {
            if (error) {
                message.error(
                    t("employees.crud.form.error.edit") + " " + error
                )
            } else {
                message.success(
                    t("employees.crud.form.edit.success")
                )
                onClose();
            }
            setIsSendForUpdate(false);
        }
    }, [isSendForUpdate, error]);
    const open = isModalOpen && modalType === "edit_categorie";

    const onSubmit = async (values) => {
        setError(null);
        setIsSendForUpdate(false);
        try {
            await updateCategorie(values, modalProps?.categorieId);
        } catch (error) {
            notification.error({
                message: t("employees.crud.form.error.edit"),
                description: error,
                role: "alert",
                duration: 3,
            });
        } finally {
            setIsSendForUpdate(true);
        }
    };

    const onClose = () => {
        form.resetFields();
        dispatch(closeModal());
    };
    
    return (
        <Modal
            title={
                <h4 style={{
                  textAlign: "center",
                  fontSize: "20px",
                  fontWeight: "bold",
                  color: "#333",
                  marginBottom: 0 }}>{t("categorieAbb.crud.form.edit")}</h4>
            }
            open={open}
            onCancel={onClose}
            destroyOnClose
            footer={[
                <Button key="cancel" onClick={onClose} className="custom-btn-1">
                    {t("employees.crud.form.button.cancel")}
                </Button>,
                <Button
                    key="submit"
                    type="primary"
                    htmlType="submit"
                    form="Categorie_Form"
                    disabled={isLoading}
                    className="custom-btn-2"
                >
                    {t("employees.crud.form.button.save")}
                </Button>,
            ]}
            centered={true} 
            styles={{ content: { overflowY: "auto", maxHeight: "75vh", width: "100%" } }}
        >
            <CategorieForm form={form} onSubmit={onSubmit} />
        </Modal>
    );
};

export default EditCategorieModal;
